<template>
  <!-- the #js-page-content id is needed for some plugins to initialize -->
  <main id="js-page-content" role="main" class="page-content" style="background:#dddae4">
    <div class="container">
        <div class="subheader">
            <h1 class="subheader-title">
                <v-icon color="secondary">mdi-book-multiple</v-icon> Colecciones
            </h1>
        </div>
       <div class="form-group">
            <div class="row">
              <div class="col-12">
                <label class="form-label" for="username">Nombre de la colección</label>
              </div>
                <div class="col-9" >
                  <input type="text" id="process" v-model="process" class="form-control" placeholder="#matrix-evolution" required :disabled="process_created">
                  <div class="invalid-feedback">No, you missed this one.</div>
                </div>
                <div class="col-2 offset-1">
                    <div class="form-group" v-if="id==0">
                      <v-btn
                        @click="save_process"
                        min-width="100%"
                        color="secondary"
                      >
                        Crear
                      </v-btn>
                    </div>
                    <div class="text-right" v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="add_schedule"
                            color="primary"
                            right
                            style="padding-left:0; padding-right:0"
                            min-width="40"
                            max-width="40"
                            icon
                            large
                            v-on="on"
                          >
                            <v-icon center large class="px-0">
                              mdi-plus-box
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Nueva Fuente de Datos</span>
                      </v-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <v-expansion-panels
          v-model="panel"
          light
        >
          <schedule v-for="schedule_id in schedule_ids" :key="'schedule'+schedule_id" :schedule_id="schedule_id" :process_id="id" :ref="'schedule'+schedule_id"></schedule>
        </v-expansion-panels>
    </div>
  </main>
</template>


<script>
import apiExtract from "@/api/modules/extract";
import Schedule from '@/components/schedule/Schedule.vue';
import store from '@/store';
let organization_id = store.getters['auth/org'];

export default {
    data() {
      return {
        panel:null,
        process: null,
        schedule_ids: [],
        process_created : false,
        process_id:null
      }
    },
    components:{
      Schedule
    },
    props: {
      id: {
        type: String,
        default: null
      }
    },
    mounted(){
        //llamando al api

        if (this.id!="0") {
          apiExtract.getProcess(organization_id, this.id)
          .then((resp)=>{
              if(resp.process.text){
                  this.process = resp.process.text;
              }
          })
          apiExtract.getSchedulers(organization_id, this.id)
          .then((resp)=>{
              this.processData(resp);
          })
        }
    },
    methods: {
        processData(resp){
          this.schedule_ids=[]
            for (var i in resp.schedulers) {
              this.schedule_ids[i]=resp.schedulers[i].id
            }

        },
        add_schedule(){
          this.schedule_ids.push(0)
          this.panel = this.schedule_ids.length-1
        },
        run_schedules(){
          for (var i in this.$refs){
            this.$refs[i][0].runSchedule()
          }
        },
        save_process(){
          if(this.id!="0"){
            apiExtract.putProcess(organization_id, this.id, this.process)
            .catch((err)=>{
                console.log(err);
            })
          }else{
            apiExtract.postProcess(organization_id, this.id, this.process)
            .then((res)=>{
              if (res.status) {
                this.$router.push('/process/'+res.id);
                this.schedule_ids.push(0)
                this.panel=0
              }
            })
            .catch((err)=>{
              console.log(err);
            })
          }
        }
    },
}
</script>
